import { createApi } from "@reduxjs/toolkit/query/react"
import { baseQueryWithReauth } from "@/app/utils"
import {
  CreateDepartmentDto,
  DepartmentDto,
  ListResponse,
  UpdateDepartmentDto,
} from "@dialogics/shared/dto/types"

export const departmentApi = createApi({
  reducerPath: "departmentApi",
  baseQuery: baseQueryWithReauth({ baseUrl: "/api/department" }),
  tagTypes: ["Department"],
  endpoints: builder => ({
    getDepartments: builder.query<ListResponse<DepartmentDto>, { organizationId?: number }>({
      query: params => ({
        url: "/list",
        method: "POST",
        body: params,
      }),
      providesTags: result =>
        result
          ? [
              ...result.results.map(({ id }) => ({ type: "Department" as const, id })),
              { type: "Department", id: "LIST" },
            ]
          : [{ type: "Department", id: "LIST" }],
    }),
    createDepartment: builder.mutation<DepartmentDto, CreateDepartmentDto>({
      query: data => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Department", id: "LIST" }],
    }),
    updateDepartment: builder.mutation<DepartmentDto, { id: number } & UpdateDepartmentDto>({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Department", id },
        { type: "Department", id: "LIST" },
      ],
    }),
    deleteDepartment: builder.mutation<DepartmentDto, number>({
      query: id => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Department", id: "LIST" }],
    }),
  }),
})

export const {
  useGetDepartmentsQuery,
  useCreateDepartmentMutation,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
} = departmentApi

